import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { authTask } from "src/common/api/authTask";

// Configure axios to include cookies in all requests
axios.defaults.withCredentials = true;

const shell = async <R extends AxiosResponse>(
  task: () => Promise<R>,
): Promise<R> => authTask(task);

export const rest = {
  get<T = unknown>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> {
    return shell(() => axios.get<T>(url, config));
  },
  post<T = unknown, D = unknown>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> {
    return shell(() => axios.post<T, AxiosResponse<T>, D>(url, data, config));
  },
  put<T = unknown, D = unknown>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> {
    return shell(() => axios.put<T, AxiosResponse<T>, D>(url, data, config));
  },
  delete<T = unknown>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> {
    return shell(() => axios.delete<T>(url, config));
  },
};

export const stdParamsSerializer = {
  indexes: null,
};
